<template>
  <v-app id="App">
    <el-scrollbar
      ref="scrollbar"
      class="ShowHeaderApplication"
      :class="[
        { firstPage: firstPage },
        {
          basketPage:
            $route.path == '/shop/basket' ||
            $route.path == '/shop/buy-subscribtion',
        },
        {
          landingPage: $route.path == '/desktop',
        },
        { taxiPage: $route.path == '/taxi/manualService' },
      ]"
      wrap-class="scrollbar-wrapper"
    >
      <router-view v-slot="{ Component }">
        <keep-alive :include="'firstPage'">
          <component :is="Component" />
        </keep-alive>
      </router-view>
      <!-- <router-view /> -->
    </el-scrollbar>
  </v-app>
</template>

<script>
import MobileDetect from "mobile-detect";
export default {
  name: "App",

  data() {
    return {
      deviceType: "Unknown",
      userAgent: "",
    };
  },
  computed: {
    firstPage() {
      return this.$route.path === "/";
    },
  },

  watch: {
    $route: {
      handler: "updateWidth",
      immediate: true,
    },
  },

  mounted() {
    this.$vuetify.rtl = true;
    this.$store.state.loading_site = true;
    this.updateWidth();
    this.detectDevice();
    this.$nextTick(() => {
      this.check_login();
    });
  },
  created() {
    if (this.$store.state.device != "Desktop") this.customer_setting();
  },
  methods: {
    detectDevice() {
      const md = new MobileDetect(window.navigator.userAgent);
      this.userAgent = window.navigator.userAgent;

      if (md.mobile()) {
        this.deviceType = "Mobile";
      } else if (md.tablet()) {
        this.deviceType = "Tablet";
      } else {
        this.deviceType = "Desktop";
      }
      this.$store.commit("setDevice", this.deviceType);
    },
    updateWidth() {
      console.log("Current path:", this.$route.path);

      this.$nextTick(() => {
        if (!this.$refs.scrollbar) {
          console.log("Scrollbar ref not found");
          return;
        }

        const el = this.$refs.scrollbar.$el;
        if (!el) {
          console.log("Scrollbar element not found");
          return;
        }

        if (
          this.$route.path.toLowerCase() === "/shop/home" ||
          this.$route.path.toLowerCase() === "/desktop"
        ) {
          el.style.width = "100%";
          el.style.paddingBottom = "0";
        } else if (this.$route.path == "/taxi/waiting-driver") {
          el.style.width = "100%";
          el.style.maxWidth = "550px";
          el.style.paddingBottom = "0";
        } else {
          el.style.width = "400px";
          el.style.paddingBottom = "67px";
        }

        if (this.$route.path.toLowerCase() === "/login") {
          const loginPage = document.querySelector(
            ".v-application.v-theme--light.v-layout.v-layout--full-height.v-locale--is-rtl"
          );
          if (loginPage) {
            loginPage.style.background = "#fff";
          }
        }
      });
    },

    customer_setting() {
      this.helperGet_taxi("customer_setting").then((res) => {
        this.$store.commit("taxi_optionSet", res.data.data);
        this.$store.dispatch("taxi_check_optionSet");

        // this.$router.push('taxi/manualService');
      });
      // .catch(error => console.log(error))
    },

    check_login() {
      this.$store.dispatch("checkAuth");
      this.$store.dispatch("check_optionSet");
      this.$store.dispatch("checkToken");
      this.$store.dispatch("checkToken_taxi");
      this.$store.dispatch("checkAuth_taxi");
      // this.$store.dispatch("taxi_check_optionSet");
    },
  },
};
</script>

<style>
.scrollbar-wrapper {
  overflow-x: hidden !important;
  width: 100%;
}
</style>
